export default class SideBar {
  showSideBar(event){
    this._handleShowSideBar(event, '#recently-projects')
  }
  showSideBarFromRecentlyTasks(event){
    this._handleShowSideBar(event, '#recently-tasks')
  }
  showSideBarRecently(event){
    this._handleShowSideBarRecently(event, '#recently-projects')
  }
  showSidebarRecentlyTasks(event) {
    this._handleShowSideBarRecently(event, '#recently-tasks')
  }
  openSubItem(event, element){
    event.preventDefault();
    event.stopPropagation();
    const parent = $(element).parent('.navbar-item');
    if (parent.length === 0) return;

    const subItem = parent.find('.sub-item');
    if (subItem.length === 0) return;

    subItem.toggleClass('d-none');
  }

  _handleShowSideBar(event, elementId) {
    $(elementId).addClass('d-none');
    $('#sidebar-recently').toggleClass('d-none');
    const dropdownAkaireFile = $('.drop-down-akaire-file');
    if (!!dropdownAkaireFile &&dropdownAkaireFile.hasClass('show')) {
      dropdownAkaireFile.removeClass('show');
    }
    event.stopPropagation()
  }

  _handleShowSideBarRecently(event, elementId) {
    $('#sidebar-recently').addClass('d-none');
    $(elementId).toggleClass('d-none');
    event.stopPropagation()
  }

  openModalCreateNew() {
    if ($('.plus.plus-icon').length > 0) {
      $('.plus.plus-icon').trigger('click');
    } else {
      $('.btn-create-new-footer').trigger('click');
    }
  }

  saveAkaireFileName(event) {
    var id = event.dataset["id"];
    var name = event.value;
    $.ajax({
      method: 'PUT',
      url: "/akaire_feature/akaire_files/" + event.dataset["id"],
      dataType: 'json',
      data: { id: id, name: name },
    }).done(function() {
      $(`.akaire-file-name-${id}`).text(name);
      // 左上メニューの最���利用した校正ページのファイル名をリ��ルタイム更新
      document.querySelectorAll('#sidebar-recently .tm-recent-akaire-list a span').forEach(function(span) {
        if (span.dataset.fileId !== String(id)) return;
        var text = span.textContent.trim() || '';
        var match = text.match(/^・(.+?)（(.+)）$/);
        if (match) {
          span.textContent = '・' + name + '（' + match[2].trim() + '）';
        }
      });
    })
  }

  showModalDownloadAnimation(ele) {
    const btnEle = $('.btn-download-video').length == 0 ? $('.btn-download-for-mobile') : $('.btn-download-video');
    const disabled = btnEle.is(":disabled")
    if(disabled) {
      Popup.alert('現在、このファイルに招待されていない状態です。<br>招待されると、ダウンロードが可能になります。');
    } else {
      $(btnEle).trigger('click');
    }
  }
}
